import _ from 'underscore';
import Backbone from 'backbone';

export default Backbone.Model.extend({
  defaults: {
    paymentMethod: null,
    creditCard: 0,
    creditCardFormVisible: true,
    pfcDescriptionVisible: true,
    allowedCreditCardTypes: [],
    show3DSecure: false,
    '3dSecure': {},
    currentCreditCardType: null,
    creditCardInfo: {},
    iban: ''
  },

  initialize: function() {
    var creditCardInfo = this.get('creditCardInfo');

    this.set({
      allowedCreditCardTypes: _.pluck(creditCardInfo, 'type'),
      '3dSecure': _.reduce(
        creditCardInfo,
        function(memo, el) {
          memo[el.type] = Boolean(el.is3dSecureUsed);

          return memo;
        },
        {}
      )
    });

    this.on('change:creditCard', this.onCreditCardChange);
  },

  onCreditCardChange: function(model) {
    model.set({
      creditCardFormVisible: model.get('creditCard') === 0
    });

    if (model.get('creditCardFormVisible')) {
      model.set({
        show3dSecure: true
      });
    } else {
      model.set({
        show3dSecure: Boolean(
          model.get('3dSecure')[model.get('currentCreditCardType')]
        )
      });
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/checkout/paymentModel.js
 **/